module.exports = __webpack_public_path__ + "05_glasses_red.db79a27e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/05_glasses_red.png
// module id = 2gnL
// module chunks = 0